import { MatIconModule } from '@angular/material/icon';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxCurrencyConfig, NgxCurrencyDirective } from 'ngx-currency';

import { LookupsFiscais } from '../../../../../../../../shared/services/structs/motor-fiscal/lookups-fiscais.struct';

/**
 * Aba "outros" do item (§6.4), só no pedido de venda.
 *
 * Pesos e tipo de item SPED nascem do cadastro do produto e ficam editáveis aqui: a nota
 * transporta o que foi de fato despachado, que nem sempre é o peso de catálogo. O número do
 * pedido do cliente é a referência que ele usa para conferir a entrega.
 */
@Component({
    selector: 'app-vd-item-aba-outros',
    standalone: true,
    imports: [
    MatIconModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        NgxCurrencyDirective,

    ],
    templateUrl: './vd-item-aba-outros.component.html',
    styleUrls: ['../abas-comum.css', './vd-item-aba-outros.component.css'],
})
export class VdItemAbaOutrosComponent {
    @Input({ required: true }) public item!: FormGroup;
    @Input({ required: true }) public lookups!: LookupsFiscais;
    @Input() public isSomenteLeitura: boolean = false;
    @Input({ required: true }) public mascaraQuantidade!: Partial<NgxCurrencyConfig>;
    @Input({ required: true }) public mascaraInteira!: Partial<NgxCurrencyConfig>;

    public get dados(): FormGroup {
        return this.item.get('dados') as FormGroup;
    }
}
